<template>
  <component
    :is="element"
    :id="id"
    :qaid="`nav-tab-${isCompact ? 'compact' : 'large'}-${activeLink}-${id}`"
    class="nav-tab"
    :class="id === activeTab ? 'is-active' : null"
    :href="url"
    :target="linkTarget"
    @click="clickTab(id)"
  >
    <div class="nav-tab__text" v-html="text" />
    <div v-if="mobileSubText" class="nav-tab__mobile-sub-text" v-html="mobileSubText" />
  </component>
</template>

<script>
import {mapState, mapMutations} from 'vuex';

export default {
  name: 'NavTab',
  props: {
    id: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    mobileSubText: {
      type: String,
      default: undefined,
    },
    url: {
      type: String,
      default: undefined,
    },
    target: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    ...mapState('navigation', ['activeLink', 'activeTab']),
    ...mapState('global', ['isCompact']),
    isLink() {
      return this.url;
    },
    element() {
      return this.isLink ? 'a' : 'button';
    },
    linkTarget() {
      return this.target === 'SAMEWINDOW' ? null : '_blank';
    },
  },
  methods: {
    ...mapMutations('navigation', ['setActiveTab']),
    clickTab(text) {
      this.isLink ? null : this.setActiveTab(text);
    },
  },
};
</script>

<style scoped lang="scss">
.nav-tab {
  display: block;
  outline: 0;

  @include breakpoint(large) {
    opacity: 0.3;

    &.is-active,
    &:hover {
      opacity: 1;
    }
  }

  &__text {
    @apply text-white;
    @apply leading-normal;
    font-size: 1.125rem;

    @include breakpoint(large) {
      @apply font-heading;
      @apply leading-none;
      font-size: 1.5rem;
    }

    @include breakpoint(xlarge) {
      font-size: 2rem;
    }
  }

  &__mobile-sub-text {
    @apply text-white;
    @apply text-sm;
    @apply font-normal;
    @apply leading-none;

    @include breakpoint(large) {
      display: none;
    }
  }

  & + .nav-tab {
    @apply mt-2;

    @include breakpoint(large) {
      @apply mt-3;
    }

    @include breakpoint(xlarge) {
      @apply mt-4;
    }
  }
}
</style>
